import { precogConstants } from "../../../actions/precog";
import { precogAccountingConstants } from "../../../actions/precog/accounting";

const defaultState = {
  status: {
    started: false,
    ended: false,
    error: false
  },
  data: []
};

export function dashboardData(state = defaultState, { type, payload }) {
  switch (type) {
  case "REMOVE_FROM_DRAFT_LIST":     
    return {
      ...state,
      draftIds: state.draftIds.filter(draft => draft !== payload)
    };
  case precogAccountingConstants.GET_DASHBOARD_DATA_START:
    return {
      ...state,
      status: {
        started: true,
        ended: false,
        error: false
      }
    };
  case precogAccountingConstants.GET_DASHBOARD_DATA_SUCCESS:
    return {
      ...state,
      status: {
        started: false,
        ended: true,
        error: false
      },
      data: payload?.toAdded ? state?.data.concat(payload?.data?._embedded?.drafts) : payload?.data?._embedded?.drafts,
      draftIds: payload?.data?._embedded?.draftIds,
      nextUrl: payload?.data?._links?.next?.href
    };
  case precogAccountingConstants.GET_DASHBOARD_DATA_ERROR:
    return {
      ...state,
      status: {
        started: false,
        ended: false,
        error: true
      }
    };
  case "CLEAR_DASHBOARD_DATA":
    return defaultState;
  case precogConstants.DELETE_DRAFT_SUCCESS:    
    return {
      ...state,
      data: state?.data?.filter(e => e.id !== payload),
      draftIds: state?.draftIds?.filter(e => e !== payload)
    };
  default:
    return state;
  }
}
